import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import { Subscription } from 'rxjs';
import { ProcessService } from 'src/app/pages/_services/process.service';
import {BaseWebservice} from '../../../../shared/base/base.webservice';

@Component({
  selector: 'app-executor-summary',
  templateUrl: './executor-summary.component.html',
  styleUrls: ['./executor-summary.component.scss']
})
export class ExecutorSummaryComponent implements OnInit {
    details:any
    private unsubscribe: Subscription[] = [];
    constructor(private router: Router, private _globalService: BaseWebservice,private processService: ProcessService) {
        this.unsubscribe.push(this._globalService.navigation$.subscribe(value => {
            if(value == 'next') {
                this.navigateToNextPage();
            }
            if(value == 'prev') {
                this.moveBack()

            }
        }))
        this.processService.getUserDetails().subscribe(response => {
            if(response['success'] == true) {
                // this.defaultAuth = {
                //     maritalStatus: response['data']['marital']['status']
                // }

                this.details = response['data']
            } else {
                //error
            }
        })
    }

    moveBack() {
        this.router.navigate([`/executor/${this._globalService.getContentForPage().previousPage}`])


    }

    @Input("isFinish") isFinish = false;
    ngOnDestroy() {
        this.unsubscribe.forEach((sb) => sb.unsubscribe());
    }
    ngOnInit(): void {

        if(!this._globalService.getProcessStatus("executor") && !this.isFinish) {
            this.processService.setProcessStep({step: "executor"}).subscribe(response => {
                if (response['success'] == true) {

                    // this.defaultAuth = {
                    //     maritalStatus: response['data']['marital']['status']
                    // }
                    // this.details = response['data']
                } else {
                    //error
                }
            })
        }

        this._globalService.setContentData()
    }




    editProfile() {
        this.router.navigate([`/executor`])
    }

    navigateToNextPage() {
        this._globalService.appGlobalProgressStatus("executor")
        this.router.navigate([`/`])
    }
}

